var Editor = require("./components/editor/editor.js");
console.log(" Load KB Frontend app");

jQuery(document).ready(function() {
    console.log(" Editor");
    Editor.init();
});

// Importing KB Frontend-App Stylesheet
// import "../../css/main/helpie.scss";
